import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CheckBox, StatusWarning } from '_components';
import styles from './Common.module.css';


class AlTemplateSelfCareRow extends React.Component {

    render() {
        return (
            <div className={styles.row}>
                <CheckBox
                    size='extra-small'
                    className={styles.checkbox}
                    checked={this.props.activity.selected}
                    title={this.props.desc}
                    label={this.props.desc}
                    onClick={() => this.props.toggleItem({ entity: 'MLTMPSELFCARE', entityKeyColumn: 'XLTMPSCNO', entityKeyValue: this.props.activity.XLTMPSCNO })}
                />
                { !this.props.activity.valid &&
                    <span className={styles.warning}>
                        <StatusWarning size='extra-small' title='Not Reimbursable based on Payer/Contract' />
                    </span>
                }
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        toggleItem: bindActionCreators(noteActions.alTemplateToggleItem, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let activity = state.entities.notes.MLTMPSELFCARE[ownprops.id];
    let scname = activity.XLTMPSCSCNO ? state.entities.masterData.MLMASTERSELFCARE[activity.XLTMPSCSCNO].SCNAME + ' - ' : '';
    let act = activity.XLTMPSCACTIVITY ? activity.XLTMPSCACTIVITY + ' - ' : '';
    let setsReps = activity.XLTMPSCSETSREPS ? activity.XLTMPSCSETSREPS + ' - ' : '';
    let desc = scname + act + setsReps;
    desc = desc.endsWith(' - ') ? desc.slice(0, -3) : desc;

    return {
        noteId: noteId,
        activity: activity,
        desc: desc
    };
}

const connectedAlTemplateSelfCareRow = connect(mapStateToProps, mapDispatchToProps)(AlTemplateSelfCareRow);
export { connectedAlTemplateSelfCareRow as AlTemplateSelfCareRow };

